import {
  ButtonProps,
  Button as MantineButton,
  UnstyledButton as MantineUnstyledButton,
  UnstyledButtonProps,
  createPolymorphicComponent,
} from "@mantine/core";
import clsx from "clsx";
import React from "react";

import styles from "./Button.module.scss";

export const UnstyledButton: ReturnType<
  typeof createPolymorphicComponent<"button", UnstyledButtonProps>
> = createPolymorphicComponent<"button", UnstyledButtonProps>(
  React.forwardRef<HTMLButtonElement, UnstyledButtonProps>((props, ref) => (
    <MantineUnstyledButton {...props} ref={ref} />
  )),
);
const Button = React.forwardRef<
  HTMLButtonElement,
  ButtonProps & { variant?: "primary" | "secondary" }
>(({ className, variant = "default", fullWidth, size, ...props }, ref) => {
  return (
    <MantineButton
      className={clsx(
        styles.button,
        // @ts-expect-error TS7053 non-existing className
        styles[variant],
        { [styles.fullWidth]: fullWidth, [styles.large]: size === "lg" },
        className,
      )}
      size={size}
      {...props}
      ref={ref}
    />
  );
});

const PolymorphicButton: ReturnType<
  typeof createPolymorphicComponent<"button", ButtonProps>
> = createPolymorphicComponent<"button", ButtonProps>(Button);
export default PolymorphicButton;
